export default __webpack_public_path__ + "static/media/gallery05.a5d547c3.jpg";